// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"fEIDN","rc-tabs-tab-active":"_9C78o","input-suffix":"_2ISTg","nav-item":"UVcCt","page-wrapper":"NQ41T","page-content":"xewp8","header-filler":"pUNSE"};